var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('OrganizationCreateModal',_vm._b({ref:"modal",on:{"organization-created":_vm.onOrganizationCreated,"close":_vm.onClose,"on-open":_vm.open}},'OrganizationCreateModal',{ adminOrganizations: _vm.adminOrganizations },false))
}
var staticRenderFns = []

export { render, staticRenderFns }